import type { ReactNode } from 'react';
import './PageHeader.css';

export interface PageHeaderProps {
  /** Main page/section title */
  title: string;
  /** Optional short description below the title */
  subtitle?: string;
  /** Optional content on the right (e.g. primary action button) */
  children?: ReactNode;
  /** Optional class name for the root wrapper */
  className?: string;
}

/**
 * Reusable page header with title, optional subtitle, and optional right-side actions.
 * Use for list/detail pages (e.g. Matters, Projects) to keep header layout consistent.
 */
const PageHeader = ({ title, subtitle, children, className = '' }: PageHeaderProps): JSX.Element => {
  return (
    <div className={`page-header ${className}`.trim()}>
      <div className="page-header__content">
        <div className="page-header__left">
          <div className="page-header__text">
            <h1 className="page-header__title">{title}</h1>
            {subtitle != null && subtitle !== '' && (
              <p className="page-header__subtitle">{subtitle}</p>
            )}
          </div>
        </div>
        {children != null && (
          <div className="page-header__right">{children}</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
